<template>
    <div class="row">
        <div class="col-12 col-md-6">
            <form role="form">
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Strona</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="shop.url">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">język</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="shop.lang">
                    </div>
                </div>
            </form>
            <div class="row">
                <div v-show="this.$route.params.id !== undefined" class="col-3">
                    <div class="btn btn-primary" @click.prevent="deleteShop()">
                        Usuń sklep
                    </div>
                </div>
                <div class="col-9">
                    <div class="btn btn-primary" @click.prevent="saveShop()">
                        Zapisz
                    </div>
                </div>
            </div>
            <div class="hr-line-dashed"></div>
        </div>
        <!-- <p>{{shop}}</p> -->
    </div>
</template>

<script>
export default {
    name: 'ShopForm',
    data() {
        return {
            shop: {
                url: '',
                lang: ''
            }
        }
    },
    created() {
        this.$route.params.id !== undefined ?
        this.getData() :
        this.$emit( 'loading', false )
    },
    methods: {
        getData() {
            this.$emit( 'loading', true )
            this.$http.get( `vnfr/${this.$route.params.env}/shops/${this.$route.params.id}` )
                .then( resp => {
                    console.log ( resp, 'data' )
                    this.shop = resp.data.shop
                    this.$emit( 'loading', false )
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        },
        deleteShop(){
           this.$emit( 'loading', true )
            this.$http.delete( `vnfr/${this.$route.params.env}/shops/${this.$route.params.id}` )
                .then( resp => {
                    console.log( 'deleted resp', resp )
                    this.$toastr.success( 'Usunięte!!' )
                    this.$emit( 'loading', false )
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        },
        saveShop(){
            this.$emit( 'loading', true )
            const url = `vnfr/${this.$route.params.env}/shops/${this.$route.params.id}`
            this.$http( {
                url: this.$route.params.id !== undefined ? url : `vnfr/${this.$route.params.env}/shops/`,
                method: this.$route.params.id !== undefined ? 'put' : 'post',
                data: this.shop
            } )
                .then( resp => {
                    console.log( resp )
                    this.$toastr.success( 'Zapisane!!' )
                    this.$emit( 'loading', false )
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        }
    }
}
</script>

<style scoped>
    .btn {
        min-width: 10vh;
        max-height: 4vh;
    }
    a {
        color:white;
    }
</style>
